import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
  DefaultConfigChunk,
  PageMetaResolver,
  provideConfig,
  provideDefaultConfig,
  UrlModule,
} from '@spartacus/core'
import { MbI18nModule } from '../translations/mb-i18n.module'
import {
  MbCheckoutShippingAddressBase
} from './components/mb-checkout-shipping-address/mb-checkout-shipping-address-base'
import {
  MbCheckoutReviewEuComponent
} from './components/mb-checkout-review/mb-checkout-review-eu/mb-checkout-review-eu.component'
import {
  MbCheckoutBillingInformationBaseComponent
} from './components/mb-checkout-billing-information/mb-checkout-billing-information-base.component'
import {
  MbCheckoutProgressComponent
} from './components/mb-checkout-progress/mb-checkout-progress.component'
import { RouterModule } from '@angular/router'
import { MbCheckoutStepService } from './services/mb-checkout-step.service'
import { mbCheckoutRoutes, mbCheckoutRoutingConfig } from './config/mb-checkout-routing-config'
import { mbCheckoutConfig } from './config/mb-default-checkout-config'
import {
  MbCheckoutPaymentComponent
} from './components/mb-checkout-payment/mb-checkout-payment.component'
import { DirectiveModule } from '../shared/directive.module'
import { NgbDropdownModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap'
import {
  MbCheckoutBillingAddressFormEuComponent
} from './components/mb-checkout-billing-information/address-forms/mb-checkout-billing-address-form-eu/mb-checkout-billing-address-form-eu.component'
import {
  MbAcademicDegreesAdapter,
  MbCheckoutBillingAddressesAdapter,
  MbCheckoutBillingFormAdapter,
  MbCheckoutContactDetailsAdapter,
  MbJobTitlesAdapter,
  MbPaymentModeAdapter,
  MbSalutationAdapter
} from './connectors'
import {
  MbOccAcademicDegreesAdapter,
  MbOccCheckoutBillingAddressesAdapter,
  MbOccCheckoutBillingFormAdapter,
  MbOccCheckoutContactDetailsAdapter,
  MbOccCheckoutReviewNotesAdapter,
  MbOccCountriesNoAccountAdapter,
  MbOccJobTitlesAdapter,
  MbOccSalutationAdapter
} from './adapters'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MbFormErrorsModule } from '../shared/components/mb-form-errors/mb-form-errors.module'
import {
  MbCheckoutNewAddressTileComponent
} from './components/mb-checkout-new-address-tile/mb-checkout-new-address-tile.component'
import { MbCheckoutReviewNotesAdapter } from './connectors/review-notes'
import { MbCartDetailsModule } from '../cart/components/mb-cart-details/mb-cart-details.module'
import {
  MbCheckoutNewShippingAddressFormEuComponent
} from './components/mb-checkout-shipping-address/address-forms/mb-checkout-new-shipping-address-form-eu/mb-checkout-new-shipping-address-form-eu.component'
import { MbOccPaymentModeAdapter } from './adapters/mb-occ-payment-mode.adapter'
import { mbFacadeProviders } from './facades/mb-facade-providers'
import {
  MbCheckoutQuoteInfoComponent
} from './components/mb-checkout-quote-info/mb-checkout-quote-info.component'
import {
  MbCheckoutBaseFormPartialComponent
} from './components/shared-form-components/mb-checkout-base-form-partial/mb-checkout-base-form-partial.component'
import {
  MbCheckoutLocationFormPartialComponent
} from './components/shared-form-components/mb-checkout-location-form-partial/mb-checkout-location-form-partial.component'
import {
  MbCheckoutVatIdFormPartialComponent
} from './components/shared-form-components/mb-checkout-vat-id-form-partial/mb-checkout-vat-id-form-partial.component'
import {
  MbCheckoutStateFormPartialComponent
} from './components/shared-form-components/mb-checkout-state-form-partial/mb-checkout-state-form-partial.component'
import {
  MbCheckoutCountryFormPartialComponent
} from './components/shared-form-components/mb-checkout-country-form-partial/mb-checkout-country-form-partial.component'
import {
  MbCheckoutNewShippingAddressFormUsComponent
} from './components/mb-checkout-shipping-address/address-forms/mb-checkout-new-shipping-address-form-us/mb-checkout-new-shipping-address-form-us.component'
import {
  MbCheckoutSalutationFormPartialComponent
} from './components/shared-form-components/mb-checkout-salutation-form-partial/mb-checkout-salutation-form-partial.component'
import {
  MbCheckoutTitleFormPartialComponent
} from './components/shared-form-components/mb-checkout-title-form-partial/mb-checkout-title-form-partial.component'
import {
  MbCheckoutContactBaseFormPartialComponent
} from './components/shared-form-components/mb-checkout-contact-base-form-partial/mb-checkout-contact-base-form-partial.component'
import {
  MbCheckoutJobTitleFormPartialComponent
} from './components/shared-form-components/mb-checkout-job-title-form-partial/mb-checkout-job-title-form-partial.component'
import {
  MbCheckoutCustomerNoFormPartialComponent
} from './components/shared-form-components/mb-checkout-customer-no-form-partial/mb-checkout-customer-no-form-partial.component'
import {
  MbCheckoutContactDetailsEuComponent
} from './components/mb-checkout-contact-details/mb-checkout-contact-details-eu/mb-checkout-contact-details-eu.component'
import {
  MbCheckoutContactDetailsUsComponent
} from './components/mb-checkout-contact-details/mb-checkout-contact-details-us/mb-checkout-contact-details-us.component'
import {
  MbCheckoutReviewBaseComponent
} from './components/mb-checkout-review/mb-checkout-review-base.component'
import {
  MbCheckoutReviewUsComponent
} from './components/mb-checkout-review/mb-checkout-review-us/mb-checkout-review-us.component'
import {
  MbCheckoutConfirmationEuComponent
} from './components/mb-checkout-confirmation/mb-checkout-confirmation-eu/mb-checkout-confirmation-eu.component'
import {
  MbCheckoutConfirmationUsComponent
} from './components/mb-checkout-confirmation/mb-checkout-confirmation-us/mb-checkout-confirmation-us.component'
import {
  MbCheckoutBillingAddressFormUsComponent
} from './components/mb-checkout-billing-information/address-forms/mb-checkout-billing-address-form-us/mb-checkout-billing-address-form-us.component'
import {
  MbCheckoutTaxExemptionFormPartialComponent
} from './components/shared-form-components/mb-checkout-tax-exemption-form-partial/mb-checkout-tax-exemption-form-partial.component'
import {
  MbCheckoutPaymentInvoicePartialComponent
} from './components/shared-form-components/mb-checkout-payment-invoice-partial/mb-checkout-payment-invoice-partial.component'
import {
  MbCheckoutBillingCommonPaymentTileComponent
} from './components/mb-checkout-billing-information/mb-checkout-billing-common-payment-tile/mb-checkout-billing-common-payment-tile.component'
import {
  MbCheckoutBillingInformationEuComponent
} from './components/mb-checkout-billing-information/mb-checkout-billing-information-eu/mb-checkout-billing-information-eu.component'
import {
  MbCheckoutBillingInformationUsComponent
} from './components/mb-checkout-billing-information/mb-checkout-billing-information-us/mb-checkout-billing-information-us.component'
import { OccMbOrderNormalizer, PAYMENT_ORDER_NORMALIZER } from './converters'
import {
  MbCheckoutBillingAddressFormEuNoVatComponent
} from './components/mb-checkout-billing-information/address-forms/mb-checkout-billing-address-form-eu-no-vat/mb-checkout-billing-address-form-eu-no-vat.component'
import {
  MbCheckoutZipCodeFormPartialComponent
} from './components/shared-form-components/mb-checkout-zip-code-form-partial/mb-checkout-zip-code-form-partial.component'
import {
  MbCheckoutCityFormPartialComponent
} from './components/shared-form-components/mb-checkout-city-form-partial/mb-checkout-city-form-partial.component'
import {
  MbCheckoutShippingAddressEuComponent
} from './components/mb-checkout-shipping-address/mb-checkout-shipping-address-eu/mb-checkout-shipping-address-eu.component'
import {
  MbCheckoutShippingAddressUsComponent
} from './components/mb-checkout-shipping-address/mb-checkout-shipping-address-us/mb-checkout-shipping-address-us.component'
import { MbCheckoutNavigationService } from './services/mb-checkout-navigation.service'
import { MbCheckoutQuoteInfoAdapter, MbCountriesNoAccountAdapter } from './connectors/quote-info'
import { MbOccCheckoutQuoteInfoAdapter } from './adapters'
import { MbCartMigrationAdapter } from '../cart/connectors'
import { MbOccCartMigrationAdapter } from '../cart/adapters'
import {
  MbCheckoutContactDetailsUnComponent
} from './components/mb-checkout-contact-details/mb-checkout-contact-details-un/mb-checkout-contact-details-un.component'
import {
  MbCheckoutNewShippingAddressFormUnComponent
} from './components/mb-checkout-shipping-address/address-forms/mb-checkout-new-shipping-address-form-un/mb-checkout-new-shipping-address-form-un.component'
import {
  MbCheckoutBillingAddressFormUnComponent
} from './components/mb-checkout-billing-information/address-forms/mb-checkout-billing-address-form-un/mb-checkout-billing-address-form-un.component'
import {
  MbCheckoutReviewUnComponent
} from './components/mb-checkout-review/mb-checkout-review-un/mb-checkout-review-un.component'
import {
  MbCheckoutConfirmationUnComponent
} from './components/mb-checkout-confirmation/mb-checkout-confirmation-un/mb-checkout-confirmation-un.component'
import { MiltenyiCheckoutPageMetaResolver } from './services/miltenyi-checkout-page-meta.resolver'
import { SharedModule } from '../shared/shared.module'
import { MbCheckoutReviewPricesAdapter } from './connectors/review-prices'
import { MbOccCheckoutReviewPricesAdapter } from './adapters/mb-occ-checkout-review-prices.adapter'
import { MbAddressTileModule } from '../shared/components/mb-address-tile/mb-address-tile.module'
import { MbCheckoutAdapter } from './connectors/checkout'
import { MbOccCheckoutAdapter } from './adapters/mb-occ-checkout.adapter'
import {
  MbCheckoutNewShippingAddressFormAuComponent
} from './components/mb-checkout-shipping-address/address-forms/mb-checkout-new-shipping-address-form-au/mb-checkout-new-shipping-address-form-au.component'
import {
  MbCheckoutShippingAddressAuComponent
} from './components/mb-checkout-shipping-address/mb-checkout-shipping-address-au/mb-checkout-shipping-address-au.component'
import {
  MbCheckoutBillingAddressFormAuComponent
} from './components/mb-checkout-billing-information/address-forms/mb-checkout-billing-address-form-au/mb-checkout-billing-address-form-au.component'
import {
  MbCheckoutBillingInformationAuComponent
} from './components/mb-checkout-billing-information/mb-checkout-billing-information-au/mb-checkout-billing-information-au.component'
import {
  MbCheckoutReviewAuComponent
} from './components/mb-checkout-review/mb-checkout-review-au/mb-checkout-review-au.component'
import {
  MbCheckoutConfirmationAuComponent
} from './components/mb-checkout-confirmation/mb-checkout-confirmation-au/mb-checkout-confirmation-au.component'
import { OccMbPaymentOrderNormalizer } from './converters'
import { MbCheckoutBillingCommonPaymentInfoTileComponent } from './components/mb-checkout-billing-common-payment-info-tile/mb-checkout-billing-common-payment-info-tile.component'
import { OrderModule } from '@spartacus/order'
import { ORDER_NORMALIZER } from '@spartacus/order/root'
import { CheckoutProgressModule } from '@spartacus/checkout/base/components'
import { CheckoutDeliveryAddressAdapter, CheckoutDeliveryAddressConnector } from '@spartacus/checkout/base/core'
import { OccCheckoutDeliveryAddressAdapter } from '@spartacus/checkout/base/occ'
import { MB_WISHLIST_NORMALIZER } from '../wishlist/converters'
import { MbWishlistNormalizer } from '../wishlist/converters/mb-wishlist-normalizer'

@NgModule({
  declarations: [
    MbCheckoutReviewUnComponent,
    MbCheckoutReviewEuComponent,
    MbCheckoutBillingInformationBaseComponent,
    MbCheckoutProgressComponent,
    MbCheckoutPaymentComponent,
    MbCheckoutNewShippingAddressFormEuComponent,
    MbCheckoutBillingAddressFormEuComponent,
    MbCheckoutNewAddressTileComponent,
    MbCheckoutQuoteInfoComponent,
    MbCheckoutBaseFormPartialComponent,
    MbCheckoutLocationFormPartialComponent,
    MbCheckoutVatIdFormPartialComponent,
    MbCheckoutStateFormPartialComponent,
    MbCheckoutCountryFormPartialComponent,
    MbCheckoutNewShippingAddressFormUsComponent,
    MbCheckoutBillingAddressFormEuNoVatComponent,
    MbCheckoutBaseFormPartialComponent,
    MbCheckoutLocationFormPartialComponent,
    MbCheckoutVatIdFormPartialComponent,
    MbCheckoutStateFormPartialComponent,
    MbCheckoutCountryFormPartialComponent,
    MbCheckoutBillingAddressFormEuNoVatComponent,
    MbCheckoutSalutationFormPartialComponent,
    MbCheckoutTitleFormPartialComponent,
    MbCheckoutContactBaseFormPartialComponent,
    MbCheckoutJobTitleFormPartialComponent,
    MbCheckoutCustomerNoFormPartialComponent,
    MbCheckoutContactDetailsEuComponent,
    MbCheckoutContactDetailsUsComponent,
    MbCheckoutContactDetailsUnComponent,
    MbCheckoutBillingAddressFormUsComponent,
    MbCheckoutTaxExemptionFormPartialComponent,
    MbCheckoutReviewBaseComponent,
    MbCheckoutReviewUsComponent,
    MbCheckoutConfirmationEuComponent,
    MbCheckoutConfirmationUsComponent,
    MbCheckoutConfirmationUnComponent,
    MbCheckoutPaymentInvoicePartialComponent,
    MbCheckoutBillingCommonPaymentTileComponent,
    MbCheckoutBillingInformationEuComponent,
    MbCheckoutBillingInformationUsComponent,
    MbCheckoutZipCodeFormPartialComponent,
    MbCheckoutCityFormPartialComponent,
    MbCheckoutShippingAddressEuComponent,
    MbCheckoutShippingAddressUsComponent,
    MbCheckoutNewShippingAddressFormUnComponent,
    MbCheckoutBillingAddressFormUnComponent,
    MbCheckoutShippingAddressAuComponent,
    MbCheckoutNewShippingAddressFormAuComponent,
    MbCheckoutBillingAddressFormAuComponent,
    MbCheckoutBillingInformationAuComponent,
    MbCheckoutReviewAuComponent,
    MbCheckoutConfirmationAuComponent,
    MbCheckoutBillingCommonPaymentInfoTileComponent
  ],
  imports: [
    CommonModule,
    UrlModule,
    RouterModule,
    CommonModule,
    MbI18nModule,
    FormsModule,
    CheckoutProgressModule,
    DirectiveModule,
    NgbDropdownModule,
    OrderModule,
    FormsModule,
    ReactiveFormsModule,
    MbFormErrorsModule,
    MbCartDetailsModule,
    RouterModule.forChild(mbCheckoutRoutes),
    NgbTypeaheadModule,
    MbAddressTileModule,
    SharedModule,
  ],
  providers: [
    ...mbFacadeProviders,
    provideDefaultConfig(mbCheckoutRoutingConfig),
    {
      provide: DefaultConfigChunk,
      useValue: mbCheckoutConfig,
      multi: true,
    },
    MbCheckoutStepService,
    MbCheckoutNavigationService,
    CheckoutDeliveryAddressConnector,
    OccCheckoutDeliveryAddressAdapter,
    provideConfig({
      cmsComponents: {
        MiltenyiCheckoutProgressBarComponent: {
          component: MbCheckoutProgressComponent,
        },
        MiltenyiCheckoutContactDetailsComponent: {
          component: MbCheckoutContactDetailsEuComponent,
        },
        MiltenyiUSCheckoutContactDetailsComponent: {
          component: MbCheckoutContactDetailsUsComponent,
        },
        MiltenyiUNCheckoutContactDetailsComponent: {
          component: MbCheckoutContactDetailsUnComponent,
        },
        MiltenyiCheckoutShippingAddressComponent: {
          component: MbCheckoutShippingAddressBase,
        },
        MiltenyiCheckoutReviewComponent: {
          component: MbCheckoutReviewEuComponent,
        },
        MiltenyiUSCheckoutReviewComponent: {
          component: MbCheckoutReviewUsComponent,
        },
        MiltenyiUNCheckoutReviewComponent: {
          component: MbCheckoutReviewUnComponent,
        },
        MiltenyiCheckoutConfirmationComponent: {
          component: MbCheckoutConfirmationEuComponent,
        },
        MiltenyiUSCheckoutConfirmationComponent: {
          component: MbCheckoutConfirmationUsComponent,
        },
        MiltenyiUNCheckoutConfirmationComponent: {
          component: MbCheckoutConfirmationUnComponent,
        },
        MiltenyiCheckoutPaymentComponent: {
          component: MbCheckoutPaymentComponent,
        },
        MiltenyiCheckoutQuoteInfoComponent: {
          component: MbCheckoutQuoteInfoComponent
        },
        MiltenyiCheckoutEUShippingAddressNoStateComponent: {
          component: MbCheckoutShippingAddressEuComponent
        },
        MiltenyiCheckoutEUShippingAddressNoStateFormComponent: {
          component: MbCheckoutNewShippingAddressFormEuComponent
        },
        MiltenyiUNCheckoutShippingAddressFormComponent: {
          component: MbCheckoutNewShippingAddressFormUnComponent
        },
        MiltenyiUSCheckoutShippingAddressComponent: {
          component: MbCheckoutShippingAddressUsComponent
        },
        MiltenyiUSCheckoutShippingAddressFormComponent: {
          component: MbCheckoutNewShippingAddressFormUsComponent
        },
        MiltenyiCheckoutEUBillingAddressNoStateNoVatIdComponent: {
          component: MbCheckoutBillingInformationEuComponent
        },
        MiltenyiCheckoutEUBillingAddressNoStateNoVatIdFormComponent: {
          component: MbCheckoutBillingAddressFormEuNoVatComponent
        },
        MiltenyiCheckoutEUBillingAddressNoStateComponent: {
          component: MbCheckoutBillingInformationEuComponent
        },
        MiltenyiCheckoutEUBillingAddressNoStateFormComponent: {
          component: MbCheckoutBillingAddressFormEuComponent
        },
        MiltenyiUSCheckoutBillingAddressNoVatIdComponent: {
          component: MbCheckoutBillingInformationUsComponent
        },
        MiltenyiUSCheckoutBillingAddressNoVatIdFormComponent: {
          component: MbCheckoutBillingAddressFormUsComponent
        },
        MiltenyiUNCheckoutBillingAddressFormComponent: {
          component: MbCheckoutBillingAddressFormUnComponent
        },
        MiltenyiAUCheckoutShippingAddressFormComponent: {
          component: MbCheckoutNewShippingAddressFormAuComponent
        },
        MiltenyiAUCheckoutShippingAddressComponent: {
          component: MbCheckoutShippingAddressAuComponent
        },
        MiltenyiAUCheckoutBillingAddressFormComponent: {
          component: MbCheckoutBillingAddressFormAuComponent
        },
        MiltenyiAUCheckoutBillingAddressComponent: {
          component: MbCheckoutBillingInformationAuComponent
        },
        MiltenyiAUCheckoutReviewComponent: {
          component: MbCheckoutReviewAuComponent
        },
        MiltenyiAUCheckoutConfirmationComponent: {
          component: MbCheckoutConfirmationAuComponent
        },
      },
    }),
    {
      provide: MbCheckoutBillingAddressesAdapter,
      useExisting: MbOccCheckoutBillingAddressesAdapter,
    },
    {
      provide: MbAcademicDegreesAdapter,
      useExisting: MbOccAcademicDegreesAdapter,
    },
    {
      provide: MbJobTitlesAdapter,
      useExisting: MbOccJobTitlesAdapter,
    },
    {
      provide: MbSalutationAdapter,
      useExisting: MbOccSalutationAdapter,
    },
    {
      provide: MbCheckoutContactDetailsAdapter,
      useExisting: MbOccCheckoutContactDetailsAdapter,
    },
    {
      provide: MbCheckoutBillingFormAdapter,
      useExisting: MbOccCheckoutBillingFormAdapter,
    },
    {
      provide: MbPaymentModeAdapter,
      useExisting: MbOccPaymentModeAdapter,
    },
    {
      provide: MbCheckoutReviewNotesAdapter,
      useExisting: MbOccCheckoutReviewNotesAdapter,
    },
    {
      provide: MbCheckoutReviewPricesAdapter,
      useExisting: MbOccCheckoutReviewPricesAdapter
    },
    {
      provide: MbCheckoutAdapter,
      useExisting: MbOccCheckoutAdapter
    },
    {
      provide: ORDER_NORMALIZER,
      useExisting: OccMbOrderNormalizer,
      multi: true,
    },
    {
      provide: PAYMENT_ORDER_NORMALIZER,
      useExisting: OccMbPaymentOrderNormalizer,
      multi: true
    },
    {
      provide: MbCheckoutQuoteInfoAdapter,
      useExisting: MbOccCheckoutQuoteInfoAdapter
    },
    {
      provide: MbCountriesNoAccountAdapter,
      useExisting: MbOccCountriesNoAccountAdapter
    },
    {
      provide: MbCartMigrationAdapter,
      useExisting: MbOccCartMigrationAdapter
    },
    {
      provide: PageMetaResolver,
      useExisting: MiltenyiCheckoutPageMetaResolver,
      multi: true,
    },
    {
      provide: CheckoutDeliveryAddressAdapter,
      useExisting: OccCheckoutDeliveryAddressAdapter
    },
    {
      provide: MB_WISHLIST_NORMALIZER,
      useExisting: MbWishlistNormalizer,
      multi: true
    }
  ],
})
export class CheckoutModule {
}
